/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.actionBar.cropImage": "Editar",
  "i18n.actionBar.removeImage": "Remover",
  "i18n.actionBar.swapImage": "Substituir",
  "i18n.additionalInfoItemLayers.smartSorted.new": "NOVO!",
  "i18n.additionalProducts.addToCart": "Adicionar à encomenda",
  "i18n.additionalProducts.frame.description": "Moldura de alumínio de alta qualidade: prateado mate, vidro verdadeiro premium, sem necessidade de cola",
  "i18n.additionalProducts.frame.emotionalHook": "♥️ Dica:",
  "i18n.additionalProducts.frame.subtitle": "O puzzle concluído transforma-se numa bonita recordação e, com a nossa <b>moldura</b>, ganha ainda mais destaque.",
  "i18n.additionalProducts.frame2023.description": "Moldura de alta qualidade em fibra de madeira – fácil de montar, sem vidro, inclui cola para puzzles",
  "i18n.additionalProducts.framePlastic.description": "Moldura de alumínio de alta qualidade: prateado mate, vidro sintético com revestimento antirreflexo, sem necessidade de cola",
  "i18n.additionalProducts.glue.description": "Para até dois puzzles de 1000 peças, inclui esponja aplicadora",
  "i18n.additionalProducts.glue.hook": "Para que o teu puzzle se torne um quadro.\nCola e protege de forma duradoura.",
  "i18n.additionalProducts.roll.description": "Para puzzles de 48 a 2000 peças",
  "i18n.additionalProducts.roll.hook": "Não tens uma mesa livre? Não há problema.\nEnrola o puzzle, guarda-o e continua mais tarde.",
  "i18n.adventCalendarOverlay.activate": "Mostrar pré-visualização das 24 janelinhas",
  "i18n.adventCalendarOverlay.deactivate": "Ocultar pré-visualização das 24 janelinhas",
  "i18n.adventCalendarOverlay.notice": "(os números e as linhas não são impressos)",
  "i18n.button.addToCart": "Adicionar ao carrinho",
  "i18n.button.apply": "Aplicar",
  "i18n.button.back": "Voltar",
  "i18n.button.cancel": "Cancelar",
  "i18n.button.cancelAndFix": "Personalizar agora",
  "i18n.button.chooseSmartSorted": "Selecionar SMART SORTED",
  "i18n.button.close": "Fechar",
  "i18n.button.continue": "Continuar",
  "i18n.button.createNewTextPlaceholders": "Introduzir texto",
  "i18n.button.ignore": "Ignorar",
  "i18n.button.ignoreAndContinue": "Continuar na mesma",
  "i18n.button.mobile.createNewTextPlaceholders": "Texto",
  "i18n.button.noChanges": "sem alteração",
  "i18n.button.ok": "Percebido!",
  "i18n.button.photos": "Fotos",
  "i18n.button.retry": "Tentar novamente",
  "i18n.button.uploadPhotos": "Carregar fotos",
  "i18n.button.withSmartSorted": "Com SMART SORTED",
  "i18n.button.withoutSmartSorted": "Sem SMART SORTED",
  "i18n.control.colorChooser.color": "Cor",
  "i18n.control.fontChooser.placeholderText": "Tipo de letra",
  "i18n.control.imageQuality.checkImages": "Verificar imagens",
  "i18n.control.imageQuality.imageSuitability": "Qualidade da imagem",
  "i18n.control.imageQuality.indicatorAltText": "Qualidade da imagem",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.templateChooser.title": "Escolher design",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Para melhor legibilidade, por favor reduz o comprimento do texto / número de caracteres por linha.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "O tipo de letra escolhido é demasiado grande para este texto.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "O tamanho máximo de letra possível para este texto foi selecionado.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "O tamanho mínimo de letra possível foi selecionado.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Por favor, insere uma quebra de linha.",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Por favor, insere uma quebra de linha ou aumenta o campo de texto.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Por favor, verifica os teus dados, nem todos os caracteres são suportados por este tipo de letra.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "Foi atingido o número máximo de caracteres.",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Foi atingido o número máximo de linhas.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Por favor, aumenta o campo de texto.",
  "i18n.dialog.deletePlaceholder.message": "Este passo não pode ser anulado.",
  "i18n.dialog.deletePlaceholder.title": "Tem a certeza que quer eliminar o marcador de posição?",
  "i18n.dialog.error.title": [
    "Ocorreu um erro",
    "Ocorreram erros"
  ],
  "i18n.dialog.insufficientImageQuality.message": "A resolução desta imagem é demasiado baixa para uma impressão ideal da imagem!",
  "i18n.dialog.smartSorted.message": "Com o SMART SORTED, montam a vossa imagem de 1000 peças de forma inovadora e sem esforço, mesmo sem modelo da imagem",
  "i18n.dialog.smartSorted.title": "Sucesso garantido no puzzle",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Por favor, clica em „{{text}}“ para personalizar o título ao teu gosto.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "O título da caixa não foi alterado.",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Continuar sem texto",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Por favor, insere a tua foto clicando no espaço reservado para imagem.",
    "Por favor, insere as tuas fotos clicando nos espaços reservados para imagem."
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "Um espaço reservado para imagem não foi preenchido.",
    "Vários espaços reservados para imagem não foram preenchidos."
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Um marcador de posição não foi alterado.",
    "Vários marcadores de posição não foram alterados."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.message": [
    "Por favor, clica nos espaços reservados para imagem e texto para personalizar o design ao teu gosto.",
    "Por favor, clica nos espaços reservados para imagem e texto para personalizar o design ao teu gosto."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.title": [
    "Foram deixados vários espaços reservados por preencher.",
    "Foram deixados vários espaços reservados por preencher."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "Por favor, clica na caixa de texto para personalizar o texto ao teu gosto.",
    "Por favor, clica na caixa de texto para personalizar o texto ao teu gosto."
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "Uma caixa de texto não foi alterada.",
    "Várias caixas de texto não foram alteradas."
  ],
  "i18n.dialog.unchangedPlaceholders.title": "marcadores de posição não alterados",
  "i18n.error.additionalInfoItemsError.message": "Não foi possível carregar uma camada de informação.",
  "i18n.error.additionalInfoItemsError.title": "Erro de carregamento",
  "i18n.error.deprecatedBrowserError.message": "O navegador que estás a usar já não é suportado. Por favor, atualiza para uma versão mais recente.",
  "i18n.error.deprecatedBrowserError.title": "i18n.error.deprecatedBrowserError.title",
  "i18n.error.designerExpiredError.message": "Interrompeste a personalização por um longo período. Não é possível continuar. Por favor, inicia o processo novamente.",
  "i18n.error.designerExpiredError.title": "Personalização terminada",
  "i18n.error.fontLoadingError.message": "Não foi possível carregar uma fonte.",
  "i18n.error.fontLoadingError.title": "Erro de carregamento",
  "i18n.error.imageLoadingError.message": "Não foi possível carregar uma imagem.\nFoi removida da galeria e da área de design.",
  "i18n.error.imageLoadingError.title": "Erro de carregamento",
  "i18n.error.imageProvisionError.message": "Uma ou mais imagens não puderam ser processadas. Talvez o formato não seja suportado.",
  "i18n.error.imageProvisionError.title": "Não foi possível processar uma imagem",
  "i18n.error.imageSelectionError.message": "O ficheiro „{{reference1}}“ não pôde ser processado.",
  "i18n.error.imageSelectionError.title": "Erro ao carregar a imagem",
  "i18n.error.imageSizeLimitExceededError.message": "A imagem que carregaste tem dimensões demasiado grandes.\nPor razões técnicas, não conseguimos processá-la.\nPor favor, reduz a imagem para menos de 180 megapixels e volta a carregá-la.",
  "i18n.error.imageSizeLimitExceededError.title": "Erro ao carregar a imagem",
  "i18n.error.imageUploadError.message": "Parece haver um problema com a ligação à Internet.\nPor favor, tenta novamente mais tarde.",
  "i18n.error.imageUploadError.title": "Erro ao carregar a imagem",
  "i18n.error.inlineSVGLoadingError.message": "A margem de tolerância „{{reference1}}“ não pôde ser carregada.",
  "i18n.error.inlineSVGLoadingError.title": "Erro de carregamento",
  "i18n.error.invalidCharConfigError.message": "A fonte está incorreta e não pode ser utilizada.",
  "i18n.error.invalidCharConfigError.title": "Fonte incorreta",
  "i18n.error.malformedProductError.message": "Um ou mais produtos não puderam ser enviados para o servidor. É possível que o produto já não esteja disponível ou que a personalização tenha demorado demasiado.\n\nLamentamos o incómodo. Por favor, inicia a personalização novamente.",
  "i18n.error.malformedProductError.title": "Erro no produto",
  "i18n.error.notInStockError.message": "O produto que escolheste não está disponível de momento.\nAtravés do nosso logótipo no canto superior esquerdo, podes aceder à página inicial. Aí podes escolher outro produto.",
  "i18n.error.notInStockError.title": "i18n.error.notInStockError.title",
  "i18n.error.offlineNotice": "A tua ligação à Internet parece estar interrompida. Podes continuar a personalizar assim que a ligação for restabelecida.",
  "i18n.error.templateLoadingError.message": "O modelo „{{ error.reference[0] }}“ não pôde ser carregado.\nPor favor, tenta novamente mais tarde.",
  "i18n.error.templateLoadingError.title": "Erro de carregamento",
  "i18n.error.transformationError.message": "A transformação não pôde ser aplicada.",
  "i18n.error.transformationError.title": "Erro na transformação",
  "i18n.error.traudlLoadingError.message": "Por favor, tenta novamente ou utiliza outra imagem.",
  "i18n.error.traudlLoadingError.title": "Não foi possível aplicar um filtro de IA.",
  "i18n.error.unsupportedMediaTypeError.message": "Formato de imagem não suportado para „{{reference1}}“.",
  "i18n.error.unsupportedMediaTypeError.title": "Erro ao carregar a imagem",
  "i18n.error.uploadProductError.message": "Um ou mais produtos não puderam ser transferidos para o servidor.\nÉ possível que haja um problema com a ligação à Internet.",
  "i18n.error.uploadProductError.title": "Erro de transmissão",
  "i18n.error.zoomModeError.message": "O teu texto do design anterior não pôde ser transferido e foi reiniciado.",
  "i18n.error.zoomModeError.title": "Texto não aplicado",
  "i18n.gallery.uploadPhotos.info": "Por favor, clica no botão “Carregar fotos”",
  "i18n.gallery.uploadProgress": [
    "A foto está a ser carregada",
    "{{current}} de {{total}} fotos carregadas"
  ],
  "i18n.price.price": "Preço",
  "i18n.price.reduction": "Poupas",
  "i18n.price.total": "Preço total",
  "i18n.priceDisplay.times": [
    "{{value}} unidades a {{pricePerUnit}}",
    "{{value}} unidades a {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Acessórios (opcional)",
  "i18n.progressOverlay.message.lines.one": "Obrigado pela excelente personalização.",
  "i18n.progressOverlay.message.lines.two": "Estamos a preparar tudo para ti...",
  "i18n.template.insertText": "Introduzir texto aqui",
  "i18n.toolbox.gallery.title": "Escolher fotos",
  "i18n.toolbox.image.title": "Editar imagem",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 imagem",
    "{{value}} imagens"
  ],
  "i18n.toolbox.layout.title": "Escolher design",
  "i18n.toolbox.layout.triggerText": "Designs",
  "i18n.toolbox.preview.title": "Pré-visualização 3D",
  "i18n.toolbox.productChooser.title": "Mudar produto",
  "i18n.toolbox.productChooser.triggerText": "Produto",
  "i18n.toolbox.text.title": "Editar texto"
};


export class LocalePtPT {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
